import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f50a286"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = {
  key: 0,
  class: "search-list"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "grid-marks"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "text"
}
const _hoisted_7 = { class: "name" }

import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import { RaIcon } from '@rafter/icon';
import { searchEngines } from '@/store/searchEngines';
import { RaRow, RaCol } from '@rafter/pc';
import { getBookmarks, getIcons } from '@/api/baseApi';
import { bookmarks } from '@/store/bookmarks';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchList',
  props: {
  list: {
    type: Array,
    default: () => [],
  },
  searchEngine: {
    type: Object,
    default: () => ({}),
  },
  searchKey: {
    type: String,
    default: '',
  },
},
  emits: ['blur'],
  setup(__props, { emit: emits }) {

const props = __props;

const listRef = ref();
const marks = ref([]);
const btnType = ref('search');


const handleClickOutside = (event) => {
  console.log(event.target.className);
  if (
    listRef.value &&
    !listRef.value.contains(event.target) &&
    event.target.className !== 'ra-input input-number'
  ) {
    emits('blur');
  }
};
const handleBtn = (value) => {
  btnType.value = value;
  if (btnType.value === 'marks') {
    getBookmarks().then((res) => {
      console.log(res);
      marks.value = res.filter((item) => item.name.includes(props.searchKey));
    });
  }
};
watch(
  () => props.searchKey,
  () => {
    if (btnType.value === 'marks') {
      handleBtn('marks');
    }
  }
);
const handleMarks = (item) => {
  bookmarks.gotoMark(item);
};
onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "list-container",
    ref_key: "listRef",
    ref: listRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({ tab: true, active: btnType.value === 'search' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleBtn('search')))
      }, " 搜索内容 ", 2),
      _createElementVNode("div", {
        class: _normalizeClass({ tab: true, active: btnType.value === 'marks' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleBtn('marks')))
      }, " 搜索书签 ", 2)
    ]),
    (btnType.value === 'search')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item,
              onClick: ($event: any) => (_unref(searchEngines).goSearch(item))
            }, [
              _createVNode(_unref(RaIcon), { icon: "Search" }),
              _createTextVNode(_toDisplayString(item), 1)
            ], 8, _hoisted_3))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(marks.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "mark",
              onClick: ($event: any) => (handleMarks(item))
            }, [
              _createElementVNode("div", {
                class: "pic",
                style: _normalizeStyle({
              background: `${
                item.icon ? ` url(${item.icon})` : item.color
              } center / cover`,
            })
              }, [
                (!item.icon)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.name), 1))
                  : _createCommentVNode("", true)
              ], 4),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
            ], 8, _hoisted_5))
          }), 128))
        ]))
  ], 512))
}
}

})